import { CommonTouchBase, RotationOption, TouchData } from '../data';
import { ZEDCamera } from '../ZEDCamera';
import { rotateByPanning, rotateByPanningAlpha, rotateByPanningBeta } from '../ZEDCameraInputHelper';
import { InputCanvasProps } from '../ZEDCameraInputManager';

export const SingleTouchRotation: CommonTouchBase & RotationOption = {
  type: 'CommonTouch',
  touchCount: 1,
  key: 'SingleTouchRotation',
  name: 'SingleTouchRotation',
  option: {
    mouseButton: 'left',
    mouseKeyCode: 'none',
    alpha: true,
    beta: true,
    inertia: 0,
    sensibilityX: 100,
    sensibilityY: 100,
  },
  attachControl(
    _camera: ZEDCamera,
    _canvasProps: InputCanvasProps,
    _isMobileOrTablet: boolean,
    _noPreventDefault?: boolean | undefined
  ) {},
  detachControl(_camera: ZEDCamera, _isMobileOrTablet: boolean) {},
  checkInputs(_camera: ZEDCamera) {},
  reset() {},
  onMousedown(camera, _touchData, _canvasProps) {
    camera.stopPlayingAnimation();
  },
  onMousemove(camera: ZEDCamera, touchData: TouchData, _canvasProps: InputCanvasProps) {
    if (SingleTouchRotation.option.alpha && SingleTouchRotation.option.beta) {
      rotateByPanning(
        camera,
        touchData.movement,
        SingleTouchRotation.option.inertia,
        SingleTouchRotation.option.sensibilityX,
        SingleTouchRotation.option.sensibilityY
      );
    } else if (SingleTouchRotation.option.alpha) {
      rotateByPanningAlpha(
        camera,
        touchData.movement,
        SingleTouchRotation.option.inertia,
        SingleTouchRotation.option.sensibilityX,
        SingleTouchRotation.option.sensibilityY
      );
    } else if (SingleTouchRotation.option.beta) {
      rotateByPanningBeta(
        camera,
        touchData.movement,
        SingleTouchRotation.option.inertia,
        SingleTouchRotation.option.sensibilityX,
        SingleTouchRotation.option.sensibilityY
      );
    }
  },
  onMouseup(_camera, _touchData, _canvasProps) {},
  onTouchStart(camera, _touchData, _canvasProps) {
    camera.stopPlayingAnimation();
  },
  onTouchMoved(camera, touchData, _canvasProps) {
    if (!touchData[0]) return;
    if (SingleTouchRotation.option.alpha && SingleTouchRotation.option.beta) {
      rotateByPanning(
        camera,
        touchData[0].movement,
        SingleTouchRotation.option.inertia,
        SingleTouchRotation.option.sensibilityX,
        SingleTouchRotation.option.sensibilityY
      );
    } else if (SingleTouchRotation.option.alpha) {
      rotateByPanningAlpha(
        camera,
        touchData[0].movement,
        SingleTouchRotation.option.inertia,
        SingleTouchRotation.option.sensibilityX,
        SingleTouchRotation.option.sensibilityY
      );
    } else if (SingleTouchRotation.option.beta) {
      rotateByPanningBeta(
        camera,
        touchData[0].movement,
        SingleTouchRotation.option.inertia,
        SingleTouchRotation.option.sensibilityX,
        SingleTouchRotation.option.sensibilityY
      );
    }
  },
  onTouchEnd(_camera: ZEDCamera, _touchData: TouchData[], _canvasProps: InputCanvasProps) {},
};
